export default Object.freeze({
  HEADER: 'HEADER',
  TEXT: 'TEXT',
  SINGLE_SELECT: 'SINGLE_SELECT',
  MULTIPLE_SELECT: 'MULTIPLE_SELECT',
});
